import mixx from '../../../../mixin/mixin.js'
import $ from 'jquery'

export default {
  mixins: [mixx],
  name: 'tventas',
  data () {
    return {
      chka: false,
      loading: false,
      lcuotas: [],
      tienda: {
        nombre_tienda: '',
        url_tienda: '',
        email: ''

      }
    }
  },

  mounted: function () {
    this.consultar()
    this.cuotas()
  },

  methods: {

    cuotas () {
      this.loading = true
      let bp = this
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'cuotas'
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i].estado = false
            }

            this.lcuotas = response.data.data
            bp.cuotasu()
          }
          this.loading = false
        })
    },
    cuotasu () {
      this.loading = true
      let bp = this
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'cuotasu'
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            for (let d = 0; d < bp.lcuotas.length; d++) {
              bp.lcuotas[d].estado = false
            }
            for (let i = 0; i < response.data.data.length; i++) {

              for (let d = 0; d < bp.lcuotas.length; d++) {
                if (response.data.data[i].id_cuota === bp.lcuotas[d].id) {
                  bp.lcuotas[d].estado = true
                  break
                }
              }
            }
          }
          this.loading = false
        })
    },
    consultar () {
      this.loading = true
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'tiendaData'
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.tienda = response.data.data[0]
          }
          this.loading = false
        })
    },
    editar () {
      this.loading = true
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'tienda',
          'data': this.tienda
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.consultar()
            this.showNotification({
              msj: 'Tienda editada.',
              bg: 'bg-green'
            })
          } else {
            this.showNotification({
              msj: 'Error al editar tienda',
              bg: 'bg-red'
            })
          }
          this.loading = false
        })
    },
    checkAll () {
      for (let i = 0; i < this.lcuotas.length; i++) {
        this.lcuotas[i].estado = this.chka
      }
    },
    editarCuotas (id) {
      console.log(id)
      this.loading = true
      let datas = {}
      for (let i = 0; i < this.lcuotas.length; i++) {
        if (this.lcuotas[i].id === id) {
          datas = { id: this.lcuotas[i].id, estado: this.lcuotas[i].estado }
          break
        }
      }
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'cuotasup',
          'data': datas
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.cuotasu()
          } else {
            this.showNotification({
              msj: 'Error al editar cuotas.',
              bg: 'bg-red'
            })
          }
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ecash/configTienda/tventas/index.js